import React, { useEffect, useMemo, useState } from 'react';
import styles from './ConfirmDialog.module.less';
import TextureNoise from '@/assets/logo.png';
import closeIcon from '@/assets/project/closewhite.png';
import { infoController } from '@/api';
import { Modal, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ConfirmDialog = (props) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);
  return (
    <Modal
      open={show}
      closeIcon={<img className={'modal-close-icon'} src={closeIcon}></img>}
      wrapClassName="custom-modal"
      onCancel={() => {
        props?.onCancel();
        setShow(false);
      }}
      footer={<></>}>
      <div className={styles.popContent}>
        <div className={styles.icon}></div>
        <div className={styles.content}>{props.content}</div>
        <div className={styles.buttons}>
          <div
            className={styles.cancelButton}
            onClick={() => {
              props?.onCancel();
              setShow(false);
            }}>
            {props.cancelTitle || t('app.cancel')}
          </div>
          <div
            className={styles.confirmButton}
            onClick={() => {
              props?.onConfirm();
              setShow(false);
            }}>
            {props.confirmTitle || t('app.confirm')}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
